<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <v-data-table
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          'items-per-page-text': 'Inscrições por página',
        }"
        :headers="headers"
        :items-per-page="10"
        :items="inscricoes"
        :loading="loading"
        loading-text="Carregando inscrições..."
        class="elevation-1"
        disable-sort
        no-results-text="Nenhuma inscrição encontrada"
      >
        <template v-slot:item="{ item: inscricao }">
          <tr
            @click="onClickInscricao(inscricao)"
            :key="inscricao.id"
            class="cursor-pointer"
          >
            <td>
              <span class="d-flex align-center justify-center">
                {{ inscricao.protocolo }}
              </span>
            </td>
            <td>
              <span class="d-flex align-center justify-center">
                {{ inscricao.matricula.etapa.nome }}
              </span>
            </td>
            <td>
              <span class="d-flex align-center justify-center">
                {{ inscricao.matricula.pessoa.nome }}
              </span>
            </td>
            <td>
              <span class="d-flex align-center justify-center">
                <v-chip
                  class="cursor-pointer"
                  outlined
                  :color="getColor(inscricao.status)"
                  >{{ getStatus(inscricao.status) }}</v-chip
                >
              </span>
            </td>
            <td>
              <span class="d-flex align-center justify-center">
                {{
                  inscricao.unidadeDestino
                    ? inscricao.unidadeDestino.nomeCompleto
                    : "-"
                }}
              </span>
            </td>
            <td>
              <span
                v-if="inscricao.status == 'DEFERIDO'"
                class="d-flex align-center justify-center"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        imprimirEncaminhamento(inscricao),
                          $event.stopPropagation()
                      "
                      >mdi-printer
                    </v-icon>
                  </template>
                  <span>Imprimir</span>
                </v-tooltip>
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-col>

    <DialogInscricao
      v-if="showDialog"
      v-model="inscricaoSelected"
      :tipoStatus="tipoStatus"
      @save="onSaveInscricao($event)"
      @close="showDialog = false"
    />
  </v-row>
</template>

<script>
import DialogInscricao from "./DialogInscricao.vue";

const tipoStatus = [
  { label: "DEFERIDO", value: "DEFERIDO", color: "green" },
  { label: "PENDENTE", value: "PENDENTE", color: "grey" },
  { label: "ELIMINADO", value: "ELIMINADO", color: "red" },
  {
    label: "AGUARDANDO CORREÇÃO",
    value: "AGUARDANDO_CORRECAO",
    color: "orange",
  },
];

export default {
  props: {
    inscricoes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    DialogInscricao,
  },

  data() {
    return {
      tipoStatus,
      inscricaoSelected: null,
      showDialog: false,

      headers: [
        { text: "Protocolo", align: "center", value: "" },
        { text: "Etapa", align: "center", value: "matricula.etapa.nome" },
        {
          text: "Nome",
          align: "center",
          value: "matricula.pessoa.nome",
        },
        { text: "Status", align: "center", value: "status" },
        {
          text: "Unidade Destino",
          align: "center",
          value: "unidadeDestino.nomeCompleto",
        },
        {
          text: "Encaminhamento",
          align: "center",
          value: "imprimirEncaminhamento.nome",
        },
      ],
    };
  },

  methods: {
    imprimirEncaminhamento(inscricao) {
      this.$router.push(`/encaminhamento-plantao/${inscricao.id}`);
    },

    getStatus(status) {
      return this.tipoStatus.find((item) => item.value === status).label;
    },

    getColor(status) {
      return this.tipoStatus.find((item) => item.value === status).color;
    },

    onClickInscricao(inscricao) {
      this.inscricaoSelected = inscricao;
      this.showDialog = true;
    },

    onSaveInscricao(inscricao) {
      this.$emit("save", inscricao);
      this.showDialog = false;
      this.inscricaoSelected = null;
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
